import { ArrowRight, Clock } from "lucide-react";
// Kit pieces by file (not the barrel): the barrel pulls in react-router-dom, which the tests can't resolve.
import { Button } from "../../ui/Button";
import { Card } from "../../ui/Card";
import { EmptyState } from "../../ui/Feedback";
import "./styles.scss";

interface Props {
  playerCount: number;
  plannedRounds: number;
  courts: number | null;
  canEditSetup: boolean;
  onEditSetup: () => void;
}

const plural = (n: number, word: string) => `${n} ${word}${n === 1 ? "" : "s"}`;

/**
 * Stage overview for a Mexicano/Roulette stage that is set up but has no round yet (spec 2026-09-29 §5).
 * Rounds are started from the referee portal. 0 planned rounds = open-ended Roulette (until Finish).
 */
const MexicanoWaiting = ({ playerCount, plannedRounds, courts, canEditSetup, onEditSetup }: Props) => (
  <Card padding="none" className="mexicano-waiting">
    <EmptyState
      icon={<Clock />}
      title="Waiting for round 1"
      description={
        <>
          <span className="mexicano-waiting__line mexicano-waiting__line--facts">
            {`${plural(playerCount, "player")} enrolled · ${
              plannedRounds > 0 ? `${plural(plannedRounds, "round")} planned` : "no round limit"
            } · ${courts ? plural(courts, "court") : "no court limit"}`}
          </span>
          <span className="mexicano-waiting__line">
            On the day, mark who has arrived and start each round from the referee portal. Late arrivals join from the
            next round.
          </span>
        </>
      }
      action={
        canEditSetup && (
          <Button onClick={onEditSetup} iconRight={<ArrowRight />}>
            Edit setup
          </Button>
        )
      }
    />
  </Card>
);

export default MexicanoWaiting;
